import React from "react";

/**
 * Reusable wave divider for smooth organic transitions between sections.
 * @param {string} fill - Hex color for the wave body (matches the section it flows into)
 * @param {boolean} flip - Flips horizontally/vertically if needed for variety
 * @param {string} className - Additional classes for container
 * @param {number} variant - 1, 2, or 3 for distinct natural wave shapes
 */
export function WaveDivider({
  fill = "#ffffff",
  flip = false,
  className = "",
  variant = 1,
}) {
  // Elegant, harmonious curves
  // Symmetrical pure arch or gentle curve
  const pathD =
    variant === 2
      ? "M0,0 C380,75 1060,75 1440,0 L1440,100 L0,100 Z"
      : variant === 3
      ? "M0,45 C360,85 720,15 1080,65 C1240,85 1360,50 1440,45 L1440,100 L0,100 Z"
      : "M0,75 C380,5 1060,5 1440,75 L1440,100 L0,100 Z";

  return (
    <div
      className={`w-full overflow-hidden leading-none pointer-events-none z-10 ${className}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`w-full h-10 sm:h-14 lg:h-18 block ${flip ? "-scale-x-100" : ""}`}
        preserveAspectRatio="none"
      >
        <path d={pathD} fill={fill} />
      </svg>
    </div>
  );
}
